class CollapsibleHeader extends Collapsible {
    constructor() {
        super();
        this.header = this.closest("[data-header]");
        this.headerWrapper = this.closest(".shopify-section-new-header");
        if (this.header) {
            this.shadow = this.header.querySelector(".header-shadow");
            this.shadow?.addEventListener("click", this.closeAll.bind(this));
        }
    }
    events() {
        if (!this.header) {
            super.events();
        }
    }
    open(group) {
        super.open(group);
        if (this.headerWrapper) {
            this.headerWrapper.classList.add("shopify-section-header--open");
        }
        this.toggleHeaderClass(true);
    }
    close(group) {
        super.close(group);
        if (this.headerWrapper) {
            this.headerWrapper.classList.remove("shopify-section-header--open");
        }
        this.toggleHeaderClass(false);
    }
    closeSiblings(currentGroup = null) {
        super.closeSiblings(currentGroup);
        this.toggleHeaderClass(false);
    }
    openAll() {
        super.openAll();
        this.toggleHeaderClass(true);
    }
    closeAll() {
        super.closeAll();
        this.toggleHeaderClass(false);
    }
    toggleHeaderClass(open = true) {
        if (!this.header) {
            return false;
        }
        if (open) {
            this.header.classList.add("header--is-open");
        } else {
            let close = true;
            this.groups.forEach((group => {
                if (group.classList.contains(this.options.toggleClass)) {
                    close = false;
                }
            }));
            if (close) {
                this.header.classList.remove("header--is-open");
            }
        }
    }
}
class ToggleMobileNavigation extends ToggleElementClass {
    constructor() {
        super();
        this.header = this.closest("[data-header]");
        this.headerWrapper = this.closest("#shopify-section-header");
        if (this.header) {
            this.shadow = this.header.querySelector(".header-shadow");
            if (navigator.platform === "iPhone") {
                document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
            }
            document.addEventListener("keyup", this.onKeyUp.bind(this));
            this.shadow?.addEventListener("click", this.remove.bind(this));
        }
    }
    //call back
    connectedCallback() {
        this.addEventListeners();
    }
    addEventListeners() {
        this.addEventListener('click', (e) => {
            if (e.target.closest(".menu-drawer__toggle-button--menu")) {
                this.toggleMenuDrawer(true);
            } else if (e.target.closest(".menu-drawer__toggle-button--close")) {
                this.toggleMenuDrawer(false);
            }
        });
    }
    toggleMenuDrawer(isOpen) {
        const { toggleClass, target } = this.options;
        const allMenuDrawers = document.querySelectorAll(target);
        allMenuDrawers.forEach(menuDrawer => {
            if (isOpen) {
                menuDrawer.classList.add(toggleClass);
            } else {
                menuDrawer.classList.remove(toggleClass);
            }
        });
    }
    // end call back
    events() {
        if (!this.header) {
            super.events();
        }
    }
    onKeyUp(event) {
        if (!this.header.classList.contains("header--is-open")) {
            return;
        }
        if (event?.code?.toUpperCase() !== "ESCAPE") {
            return;
        }
        const {
            toggleClass
        } = this.options;
        const allMenuDrawers = document.querySelectorAll(this.options.target);
        allMenuDrawers.forEach(menuDrawer => {
            if (menuDrawer.classList.contains(toggleClass)) {
                this.remove();
            }
        });
    }
    add() {
        super.add();
        if (this.header) {
            this.header.classList.add("header--is-open");
        }
        if (this.headerWrapper) {
            this.headerWrapper.classList.add("shopify-section-header--open");
        }
        trapFocus(this.header);
    }
    remove() {
        super.remove();
        if (this.header) {
            this.header.classList.remove("header--is-open")
        }
        if (this.headerWrapper) {
            this.headerWrapper.classList.remove("shopify-section-header--mobile-open")
        }
        this.closeAllSiblings();
        removeTrapFocus();
    }
    closeAllSiblings() {
        const collapsibles = this.target.querySelector("collapsible-element");
        collapsibles.closeAll();
    }
}

class ToggleSearch extends HTMLElement {
    constructor() {
        super();
        this.header = this.closest("[data-header]");
        this.form = this.querySelector("form");
        this.input = this.querySelector('input[type="search"]');
        this.closeButton = this.querySelector("[data-search-close]");
        document.addEventListener("keyup", this.onKeyUp.bind(this));
        if(this.closeButton) {
          this.closeButton.addEventListener("click", this.close.bind(this));  
        }
        
        this.addEventListener("click", (e => {
            if (e.target.closest(".search-modal__button") || e.target.closest(".predictive-search__list-item--action")) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (this.input.value.length === 0) {
                    this.input.focus();
                    return;
                }
                this.form.submit();
            }
        }));
        document.querySelector(".header-shadow").addEventListener("click", (e => {
            if (this.header.classList.contains("header__search--is-active")) {
                this.header.classList.remove("header__search--is-active");
            }
        }))
    }
    onKeyUp(event) {
        if (event?.code?.toUpperCase() !== "ESCAPE") {
            return;
        }
        this.close();
    }
    close() {
        this.header?.classList.remove("header__search--is-active");
        removeTrapFocus();
    }
}

class StickyHeader extends HTMLElement {
    constructor() {
        super();
        this.header = document.querySelector("[data-header]");
        this.headerWrapper = document.querySelector("#shopify-section-header");
        this.announcementBar = document.querySelector("#shopify-section-announcement-bar");
        this.headerElement = this;
        this.headerNav = this.querySelector("collapsible-header");
        this.mobileNav = this.querySelector("toggle-mobile-navigation");
        this.search = this.querySelector("[data-header-search]");
        this.searchToggle = this.querySelector("toggle-search");
        this.productInfo = document.querySelector("[data-product-info]");
        if (this.headerWrapper) {
            this.currentScrollTop = 0;
            this.scrollOffset = 0;
            this.headerStart = 0;
            if (this.announcementBar) {
                const announcementBarHeight = this.announcementBar.offsetHeight;
                this.scrollOffset += announcementBarHeight;
                this.headerStart += announcementBarHeight;
            }
            if (this.headerElement) {
                this.scrollOffset += this.headerElement.offsetHeight;
            }
            this.raf = null;
            this.timer = null, window.addEventListener("scroll", (() => {
                clearTimeout(this.timer);
                if (!this.raf) {
                    this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
                }
                this.timer = setTimeout((() => {
                    cancelAnimationFrame(this.raf);
                    this.raf = null;
                }), 50);
            }), false);
        }
    }
    scrollAnimation() {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight && window.innerWidth <= 1024) {
            this.revealTop();
            return;
        }
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (!this.header?.classList?.contains("header--is-open")) {
            if (scrollTop + window.innerHeight > document.body.clientHeight) {
                this.hide();
            } else if (scrollTop > this.currentScrollTop && scrollTop > this.scrollOffset) {
                this.hide();
            } else if (scrollTop <= this.headerStart) {
                this.revealTop();
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerStart) {
                this.reveal();
            }
        }
        this.currentScrollTop = scrollTop;
        this.raf = requestAnimationFrame(this.scrollAnimation.bind(this));
    }
    hide() {
        this.headerWrapper.classList.add("shopify-section-header--hidden", "shopify-section-header--sticky");
        this.closeHeaderNav();
        this.closeMobileNav();
        this.closeSearch();
        this.productInfoPosition("up");
    }
    reveal() {
        this.headerWrapper.classList.add("shopify-section-header--sticky", "shopify-section-header--animate");
        this.headerWrapper.classList.remove("shopify-section-header--hidden");
        this.productInfoPosition("down");
    }
    revealTop() {
        this.headerWrapper.classList.remove("shopify-section-header--hidden", "shopify-section-header--sticky", "shopify-section-header--animate");
        this.productInfoPosition("up");
    }
    closeHeaderNav() {
        if (!this.headerNav || window.innerWidth < 768) {
            return false;
        }
        this.headerNav.closeAll();
    }
    closeMobileNav() {
        if (!this.mobileNav) {
            return false;
        }
        this.mobileNav.remove();
    }
    closeSearch() {
        if (!this.search || !this.searchToggle) {
            return false;
        }
        if (this.search.classList.contains("header__search--is-active")) {
            this.searchToggle.remove();
        }
    }
    productInfoPosition(pos = "up") {
        if (!this.productInfo) {
            return;
        }
        if (pos == "down") {
            this.productInfo.classList.add("product-info-col--sticky-with-header");
        } else {
            this.productInfo.classList.remove("product-info-col--sticky-with-header");
        }
    }
}
if (!customElements.get("collapsible-header")) {
    customElements.define("collapsible-header", CollapsibleHeader);
}
if (!customElements.get("toggle-mobile-navigation")) {
    customElements.define("toggle-mobile-navigation", ToggleMobileNavigation);
}
if (!customElements.get("toggle-search")) {
    customElements.define("toggle-search", ToggleSearch);
}
if (!customElements.get("sticky-header")) {
    customElements.define("sticky-header", StickyHeader);
}